export enum ApplicationCloseReason {
  securityTermination = 'Security Termination',
  excessiveChargebacks = 'Excessive Chargebacks',
  achRejectsCollections = 'ACH Rejects/Collections',
  cardBrandNotice = 'Card Brand Notice',
  compliance = 'Compliance',
  bankTermination = 'Bank Termination',
  fraud = 'Fraud',
  retroMATCH = 'Retro-MATCH',
  seasonalClosure = 'Seasonal Closure',
  agentRequest = 'Agent Request',
  merchantRequest = 'Merchant Request',
  highFinancialExposure = 'High Financial Exposure',
}

export interface ApplicationCloseReasonItem {
  text: string;
}

// Get sorted array of objects
export const SortedApplicationCloseReasons: ApplicationCloseReasonItem[] = Object.values(
  ApplicationCloseReason
)
  .map(x => ({text: x}))
  .sort((a, b) => a.text.localeCompare(b.text));
